/* mapping  between static route and resource for title*/
export default {
  '/filter/all/all/all/all/starting-soon': 'staticLinks.soon',
  '/filter/all/all/all/all/starting-soon,upcoming-live': 'staticLinks.soon',
  '/filter/all/all/all/all/in-play': 'staticLinks.live',
  '/bethistory/:date/:couponType?': 'staticLinks.betHistory',
  '/bethistory/detail/:couponId': 'staticLinks.betHistory'
};
